// The `sizes` attribute for each responsive site image. Shared between the
// React pages (the <img> tags) and scripts/preload-postbuild.js (the
// <link rel="preload"> tags in the static HTML) so the browser picks the same
// candidate from both and the preloaded file is the one the page uses.

// .home-logo in src/index.css: 100px, 68px under 600px wide.
export const HOME_LOGO_SIZES = '(max-width: 600px) 68px, 100px';

// .logo-image / .zero-proof-logo-image: the 50px header logos.
export const HEADER_LOGO_SIZES = '50px';

// .cv-hero-logo in src/civitas/Civitas.css: clamp(96px, 22vw, 132px). Also
// warmed from the home page.
export const CIVITAS_HERO_LOGO_SIZES = '(max-width: 436px) 96px, (max-width: 600px) 22vw, 132px';

// .zero-proof-hero-image: full width on phones, half of a 1400px max container
// with 24px padding on larger screens.
export const ZEROPROOF_HERO_SIZES = '(min-width: 768px) min(50vw, 676px), calc(100vw - 48px)';

// The Longevity Checklist hero phone (src/LongevityPage.js), also warmed from
// the home page and preloaded by scripts/longevity-postbuild.js.
export const LONGEVITY_HERO_SIZES = '(min-width: 900px) 320px, min(70vw, 300px)';
